// extracted by mini-css-extract-plugin
export default {"skeleton":"JOe_K6bB","shimmerMobile":"wTtjfA1C","shimmerDesktop":"B07u4Rga"};